import { useErrorLogger } from '@/hooks/use-error-logger';
import { redoInAppAssessmentResult } from '@/lib/api-calls';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

/**
 * Clears one completed result from the opener tree so a Picture-in-Picture remount
 * does not drop the in-flight request.
 */
export function useInAppAssessmentRedo({ onRedone }: { onRedone: (assessmentResultId: string) => void }) {
  const logError = useErrorLogger();
  const { mutate, isPending } = useMutation({
    mutationFn: redoInAppAssessmentResult,
  });

  const redo = useCallback(
    (assessmentResultId: string, reason: string) => {
      mutate(
        { id: assessmentResultId, reason },
        {
          onSuccess: () => onRedone(assessmentResultId),
          onError: (error) => {
            logError(error, { component: 'in-app-assessment', action: 'redo-result' });
          },
        },
      );
    },
    [logError, mutate, onRedone],
  );

  return { redo, redoPending: isPending };
}
